module.exports = __webpack_public_path__ + "static/media/yoshi_0.218f7dce.png";